import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './sidebar'
import version from './version'
import tree from './tree'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    sidebar: sidebar,
    version: version,
    tree: tree,
  },
})
